// @ts-nocheck
import * as actionTypes from './rightClickMenuActionTypes';

const overrideRightClickMenu = (overrides) => ({
  type: actionTypes.OVERRIDE_RIGHT_CLICK_MENU,
  overrides,
});

export { overrideRightClickMenu };
